// extracted by mini-css-extract-plugin
export var md = "_4q-4";
export var semantic = "_4q-5";
export var sm = "_4q-3";
export var text = "_4q-6";
export var toggleInput = "_4q-0";
export var toggleSwitch = "_4q-1";
export var xs = "_4q-2";